// useAddressLabels.js

import { useMemo } from "react";

export function useAddressLabels(sortedAddressFields) {

  const lookup = useMemo(() => {
    if (!sortedAddressFields) return {};

    return Object.fromEntries(
      Object.entries(sortedAddressFields).map(([type, fields]) => [
        type,
        Object.fromEntries(
          fields.map(f => [
            f.field.toLowerCase(),
            f.label || f.field
          ])
        )
      ])
    );
  }, [sortedAddressFields]);

  const getLabel = (addressType, fieldName, fallback = null) => {
    if (!addressType || !fieldName) return fallback;

    const label = lookup[addressType]?.[fieldName.toLowerCase()];

    if (label === undefined || label === "") return fallback;

    return label;
  };

  return { getLabel, lookup };
}
